import { FC, useMemo } from "react"
import classNames from "classnames"
import { Button } from "@eventbrite/marmalade"

// utils
import { getPanelId, getTabId } from "./Tabs"

// styles
import { edsHide } from "../../../theme/global.module.scss"
import * as globalStyles from "../../../theme/global.module.scss"
import {
  tabItemContainer,
  tabItemButton,
  tabItemSelected,
  tabItemButtonSelected
} from "./TabItem.module.scss"
import { events } from "../../../utils/heap/tracking_events"

import { BaseState } from "../../../store/slices/metadata.slice"

export type SingleTabContentObject = {
  title: string
  slug: string
  id: string
}

export type SingleTabItem = {
  node: SingleTabContent
}

export type SingleTabContent = {
  displayName: string
  content?: SingleTabContentObject[]
  isSelected?: boolean
}

export interface Props extends SingleTabContent {
  onSelected: (
    displayName: string,
    audienceEnglishCategory: BaseState["audienceEnglishCategory"]
  ) => void
  landingPageVariationInternalTitle: BaseState["audienceEnglishCategory"]
  tourStepAttr?: string
}

export const TabItem: FC<Props> = ({
  displayName,
  isSelected,
  onSelected,
  landingPageVariationInternalTitle,
  tourStepAttr
}) => {
  // @TODO: more classNames that need refactor
  const tabItemClasses = useMemo(
    () =>
      classNames(
        tabItemContainer,
        // @ts-expect-error typed-scss-modules generates `edsTabsItem`; webpack css-loader exports `edsTabs__item`. See README "Stylesheets".
        globalStyles.edsTabs__item,
        // @ts-expect-error typed-scss-modules generates `edsLPadHor_2`; webpack css-loader exports `edsLPadHor2`. See README "Stylesheets".
        globalStyles.edsLPadHor2,
        {
          [`${tabItemSelected}`]: isSelected,

          // When displayName is not set we want to hide it
          // or else there will be a gap
          [`${edsHide}`]: !displayName
        }
      ),
    [isSelected, displayName]
  )

  const tabItemLinkClasses = useMemo(
    () =>
      classNames(tabItemButton, { [`${tabItemButtonSelected}`]: isSelected }),
    [isSelected]
  )

  let controlledPanel

  if (isSelected) {
    controlledPanel = getPanelId(displayName)
  }

  return (
    <li
      id={getTabId(displayName).split(" ").join("")}
      className={tabItemClasses}
      aria-controls={controlledPanel?.split(" ").join("")}
    >
      <Button
        data-tour-step={tourStepAttr}
        className={tabItemLinkClasses}
        onClick={() => {
          events?.handleHomepageTabClick(displayName, TabItem?.name)

          onSelected(displayName, landingPageVariationInternalTitle)
        }}
      >
        <span>{displayName}</span>
      </Button>
    </li>
  )
}
